import React, { useEffect, useState } from 'react';

export default function RestApi() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const api = async () => {
      const res = await fetch('https://gorest.co.in/public/v2/users');
      const response = await res.json();
      setData(response);
    };
    api();
  }, []);

  //////////////////////////////////////
  return (
    <div className='list-group'>
      {data?.map((item) => {
        return (
          <div
            className='d-flex gap-2 w-100 justify-content-between list-group-item list-group-item-action d-flex gap-3 py-3'
            key={item.id}
          >
            <div>
              <h6 className='mb-0'>Name : {item.name}</h6>
              <h6 className='mb-0'>Email : {item.email}</h6>
              <h6 className='mb-0 '>Gender : {item.gender}</h6>
              <h6 className='mb-0 '>Status : {item.status}</h6>
            </div>
          </div>
        );
      })}
    </div>
  );
}
